// DatabaseBackup.js - الملف كامل
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// في أعلى DatabaseBackup.js تأكد من وجود:
import { 
  ArrowRight, 
  Save, 
  Download, 
  Trash2, 
  AlertCircle, 
  Check, 
  Database,
  RefreshCw,
  Shield,
  Archive,
  FileText,
  CreditCard,
  Users,
  Building2,
  Stamp,
  UserCheck,
  Clock,
  Plus,
  Settings,
  Play,
  Pause,
  Code2,
  Upload
} from 'lucide-react';
import config from '../config';

const DatabaseBackup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [confirmModal, setConfirmModal] = useState({ open: false, type: '', table: '' });
  const [backupFiles, setBackupFiles] = useState([]);
  const [loadingBackups, setLoadingBackups] = useState(false);
  const [schedules, setSchedules] = useState([]);
  const [showScheduleForm, setShowScheduleForm] = useState(false);
  const [scheduleData, setScheduleData] = useState({
    times: ['09:00'],
    backupType: 'sql'  // يمكن أن يكون: 'sql', 'bak', 'both'
  });
  const [restoreModal, setRestoreModal] = useState({ open: false, filename: '', type: '' });




  // إضافة هذه المتغيرات بعد المتغيرات الموجودة
const [securityModal, setSecurityModal] = useState({
  open: false,
  type: '',
  action: '',
  data: null,
  step: 1,
  confirmText: '',
  userInput: '',
  countdown: 10
});
const [countdownTimer, setCountdownTimer] = useState(null);



  const [reorderModal, setReorderModal] = useState({ open: false, startingId: '' });
const [reorderLoading, setReorderLoading] = useState(false);
const [devMode, setDevMode] = useState(false);




  // قائمة الجداول المتاحة للحذف
  const databaseTables = [
    {
      name: 'الجوازات',
      tables: ['Passports', 'passport_professional_details', 'passport_images'],
      icon: <FileText className="w-5 h-5" />,
      color: 'text-emerald-600',
      description: 'جميع بيانات الجوازات والصور المرفقة'
    },
    {
      name: 'التأشيرات',
      tables: ['VisaNetRegistrations', 'ConsulatePrepration', 'Visas'],
      icon: <Stamp className="w-5 h-5" />,
      color: 'text-indigo-600',
      description: 'بيانات التأشيرات وتجهيزات القنصلية'
    },
    {
        name: 'الحسابات المالية',
        tables: [
          // البنوك والحسابات الأساسية
          'Banks', 'BankAccounts', 'Accounts',
          
          // حسابات العملاء والمناديب والموظفين
          'ClientAccounts', 'DelegateAccounts', 'EmployeeAccounts',
          
          // الخزينة الشاملة
          'Treasury', 'TreasuryLog', 'TreasuryTransactions',
          
          // معاملات الشركة
          'CompanyTransactions', 'CompanyPayments', 'CompanyPaymentVersions',
          
          // معاملات البنوك والحسابات
          'BankAccountTransactions', 'WalletTransactions',
          
          // معاملات العملاء والمناديب والموظفين
          'ClientTransactions', 'DelegateTransactions', 'EmployeeTransactions',
          'ClientTransfers', 'ClientRequiredPaymentHistory',
          
          // المدفوعات والديون
          'PaymentTransactions', 'PaymentMethods', 'AdvancePayments', 
          'DebtPayments', 'DelegateDebts', 'EmployeeAdvances',
          
          // العمولات والإعدادات المالية - هنا المشكلة!
          'DelegateCommissions', 'CommissionSettings', 'GlobalCommissionSettings',
          'CompanyCommissionSettings', 'DelegateCommissionSettings',
          
          // التصنيفات والإعدادات
          'AccountCategories', 'TransactionCategories', 'RevenueTypes', 'ExpenseTypes',
          
          // المعاملات العامة
          'transactions'
        ],
        icon: <CreditCard className="w-5 h-5" />,
        color: 'text-purple-600',
        description: 'جميع الحسابات المالية: البنوك، الخزينة، إيرادات ومصروفات الشركة، حسابات العملاء والمناديب والموظفين، المعاملات، العمولات، والتصنيفات المالية'
      },
    {
      name: 'الشركات والمناديب',
      tables: ['Companies', 'Delegates'],
      icon: <Building2 className="w-5 h-5" />,
      color: 'text-blue-600',
      description: 'بيانات الشركات والمناديب'
    },
    {
      name: 'الموارد البشرية',
      tables: ['HumanResources', 'Employees'],
      icon: <UserCheck className="w-5 h-5" />,
      color: 'text-teal-600',
      description: 'بيانات العمالة والموظفين'
    },
    {
      name: 'المستخدمين والصلاحيات',
      tables: ['Users', 'UserPermissions'],
      icon: <Users className="w-5 h-5" />,
      color: 'text-red-600',
      description: 'حسابات المستخدمين والصلاحيات'
    }
  ];

  useEffect(() => {
    fetchBackupList();
    fetchSchedules();
  }, []);

  const showMessage = (msg, type) => {
    setMessage(msg);
    setMessageType(type);
    setTimeout(() => {
      setMessage('');
      setMessageType('');
    }, 5000);
  };

  // جلب قائمة النسخ الاحتياطية
// في DatabaseBackup.js - تأكد من دالة fetchBackupList:
const fetchBackupList = async () => {
  setLoadingBackups(true);
  try {
    console.log('🔄 طلب قائمة النسخ الاحتياطية...');
    
    const response = await fetch(`${config.API_BASE_URL}/api/backup/list`);
    const data = await response.json();
    
    console.log('📋 استجابة الخادم:', data);
    
    if (data.success) {
      console.log(`✅ تم جلب ${data.backups.length} نسخة احتياطية`);
      console.log('📊 البيانات المستلمة:', data.backups);
      setBackupFiles(data.backups);
    } else {
      console.error('❌ فشل في جلب النسخ:', data.message);
      showMessage(data.message || 'فشل في جلب قائمة النسخ الاحتياطية', 'error');
      setBackupFiles([]);
    }
  } catch (error) {
    console.error('💥 خطأ في الشبكة:', error);
    showMessage('خطأ في الاتصال بالخادم', 'error');
    setBackupFiles([]);
  } finally {
    setLoadingBackups(false);
  }
};

  // رفع ملف نسخة احتياطية من جهاز المستخدم
  const [uploadingBackup, setUploadingBackup] = useState(false);
  const handleUploadBackup = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!file) return;
    setUploadingBackup(true);
    try {
      const form = new FormData();
      form.append('file', file);
      const response = await fetch(`${config.API_BASE_URL}/api/backup/upload`, { method: 'POST', body: form });
      const data = await response.json().catch(() => ({}));
      if (response.ok && data.success) {
        showMessage(`${data.message} (${data.fileName})`, 'success');
        fetchBackupList();
      } else {
        showMessage(data.message || 'فشل رفع النسخة', 'error');
      }
    } catch (error) {
      showMessage('خطأ في الاتصال بالخادم', 'error');
    } finally {
      setUploadingBackup(false);
    }
  };

  // جلب الجدولة الحالية
  const fetchSchedules = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/api/backup/schedule`);
      const data = await response.json();
      
      if (data.success) {
        setSchedules(data.schedules);
      }
    } catch (error) {
      console.error('خطأ في جلب الجدولة:', error);
    }
  };

  // عمل نسخة احتياطية كاملة
  const handleFullBackup = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${config.API_BASE_URL}/api/backup/full`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (data.success) {
        showMessage(`تم إنشاء النسخة الاحتياطية بنجاح في D:\\backups\\${data.fileName} (${data.fileSize})`, 'success');
        fetchBackupList();
      } else {
        showMessage(data.message || 'فشل في إنشاء النسخة الاحتياطية', 'error');
      }
    } catch (error) {
      showMessage('خطأ في الاتصال بالخادم', 'error');
    } finally {
      setLoading(false);
    }
  };

// استبدل دالة handleSaveSchedule بهذا:
const handleSaveSchedule = async () => {
  try {
    const validTimes = scheduleData.times.filter(time => {
      return time && time.trim() !== '' && time.includes(':') && time.match(/^\d{2}:\d{2}$/);
    });
    
    console.log('الأوقات المُدخلة:', scheduleData.times);
    console.log('الأوقات الصحيحة:', validTimes);
    console.log('نوع النسخة:', scheduleData.backupType);
    
    if (validTimes.length === 0) {
      showMessage('يجب تحديد وقت صحيح واحد على الأقل (مثال: 09:00)', 'error');
      return;
    }

    const response = await fetch(`${config.API_BASE_URL}/api/backup/schedule`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        times: validTimes,
        backupType: scheduleData.backupType
      })
    });

    const data = await response.json();

    if (data.success) {
      let typeText = '';
      switch(scheduleData.backupType) {
        case 'both':
          typeText = 'مختلطة (SQL + أصلية)';
          break;
        case 'bak':
          typeText = 'أصلية (.bak)';
          break;
        default:
          typeText = 'SQL (.sql)';
      }
      
      showMessage(`تم حفظ الجدولة بنجاح! سيتم عمل نسخ ${typeText} في: ${validTimes.join(', ')}`, 'success');
      setShowScheduleForm(false);
      setScheduleData({ times: ['09:00'], backupType: 'sql' });
      fetchSchedules();
    } else {
      showMessage(data.message || 'فشل في حفظ الجدولة', 'error');
    }
  } catch (error) {
    console.error('خطأ في حفظ الجدولة:', error);
    showMessage('خطأ في الاتصال بالخادم', 'error');
  }
};


  const handleReorderPassportIds = async () => {
    if (!reorderModal.startingId || isNaN(parseInt(reorderModal.startingId)) || parseInt(reorderModal.startingId) < 1) {
      showMessage('يرجى إدخال رقم صحيح أكبر من 0', 'error');
      return;
    }
  
    setReorderLoading(true);
    try {
      const response = await fetch(`${config.API_BASE_URL}/api/backup/passports/reorder-ids`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
          startingId: parseInt(reorderModal.startingId) 
        })
      });
  
      const result = await response.json();
  
      if (result.success) {
        showMessage(result.message, 'success');
      } else {
        showMessage(result.message || 'فشل في إعادة ترتيب أرقام الجوازات', 'error');
      }
    } catch (error) {
      showMessage('خطأ في الاتصال بالخادم', 'error');
    } finally {
      setReorderLoading(false);
    }
  };


  // إيقاف الجدولة
  const handleStopSchedule = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/api/backup/schedule`, {
        method: 'DELETE'
      });

      const data = await response.json();

      if (data.success) {
        showMessage(data.message, 'success');
        fetchSchedules();
      } else {
        showMessage(data.message || 'فشل في إيقاف الجدولة', 'error');
      }
    } catch (error) {
      showMessage('خطأ في الاتصال بالخادم', 'error');
    }
  };

  // أضف هذه الدالة في DatabaseBackup.js
const handleRestoreNative = async (filename) => {
  setLoading(true);
  try {
    const response = await fetch(`${config.API_BASE_URL}/api/backup/restore-native/${filename}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (data.success) {
      showMessage(data.message, 'success');
    } else {
      showMessage(data.message || 'فشل في استعادة النسخة الأصلية', 'error');
    }
  } catch (error) {
    showMessage('خطأ في الاتصال بالخادم', 'error');
  } finally {
    setLoading(false);
  }
};

  // إضافة وقت جديد
  const addTimeSlot = () => {
    const newTime = '12:00';
    setScheduleData(prev => ({
      ...prev,
      times: [...prev.times, newTime]
    }));
  };

  const removeTimeSlot = (index) => {
    if (scheduleData.times.length <= 1) {
      showMessage('يجب الاحتفاظ بوقت واحد على الأقل', 'error');
      return;
    }
    
    setScheduleData(prev => ({
      ...prev,
      times: prev.times.filter((_, i) => i !== index)
    }));
  };

  // تحديث وقت
  const updateTimeSlot = (index, value) => {
    setScheduleData(prev => ({
      ...prev,
      times: prev.times.map((time, i) => i === index ? value : time)
    }));
  };

// دوال الأمان والحماية - أضف هذا الكود بعد الدوال الموجودة

// تشغيل العد التنازلي
const startCountdown = () => {
  let timeLeft = 10;
  setSecurityModal(prev => ({ ...prev, countdown: timeLeft }));
  
  const timer = setInterval(() => {
    timeLeft -= 1;
    setSecurityModal(prev => ({ ...prev, countdown: timeLeft }));
    
    if (timeLeft <= 0) {
      clearInterval(timer);
    }
  }, 1000);
  
  setCountdownTimer(timer);
};

// فتح نافذة الأمان
const openSecurityModal = (type, action, data = null) => {
  let confirmText = '';
  
  switch (action) {
    case 'deleteAll':
      confirmText = 'حذف قاعدة البيانات بالكامل';
      break;
    case 'deleteTables':
      confirmText = `حذف بيانات ${data?.name}`;
      break;
    case 'restoreReplace':
      confirmText = `استبدال البيانات بالملف ${data}`;
      break;
    case 'restoreAdd':
      confirmText = `إضافة بيانات من الملف ${data}`;
      break;
    case 'restoreNative':  // إضافة هذا الجديد
      confirmText = `استعادة أصلية للملف ${data}`;
      break;
    case 'deleteBackup':
      confirmText = `حذف النسخة الاحتياطية ${data}`;
      break;
    case 'reorderPassports':
      confirmText = 'إعادة ترقيم جميع الجوازات';
      break;
    default:
      confirmText = 'تأكيد العملية';
  }
  
  setSecurityModal({
    open: true,
    type,
    action,
    data,
    step: 1,
    confirmText,
    userInput: '',
    countdown: 10
  });
  
  setTimeout(() => {
    startCountdown();
  }, 500);
};

// إغلاق نافذة الأمان
const closeSecurityModal = () => {
  if (countdownTimer) {
    clearInterval(countdownTimer);
    setCountdownTimer(null);
  }
  
  setSecurityModal({
    open: false,
    type: '',
    action: '',
    data: null,
    step: 1,
    confirmText: '',
    userInput: '',
    countdown: 10
  });
};

// الانتقال للخطوة التالية
const nextSecurityStep = () => {
  if (securityModal.step === 1 && securityModal.countdown <= 0) {
    setSecurityModal(prev => ({ ...prev, step: 2 }));
  } else if (securityModal.step === 2 && securityModal.userInput === securityModal.confirmText) {
    executeSecureAction();
  }
};

// في دالة executeSecureAction أضف case جديد:
const executeSecureAction = async () => {
  const { action, data } = securityModal;
  
  closeSecurityModal();
  
  switch (action) {
    case 'deleteAll':
      await handleDeleteAllDatabase();
      break;
    case 'deleteTables':
      await handleDeleteTables(data);
      break;
    case 'restoreReplace':
      await handleRestoreBackup(data, true);
      break;
    case 'restoreAdd':
      await handleRestoreBackup(data, false);
      break;
    case 'restoreNative':  // إضافة هذا الجديد
      await handleRestoreNative(data);
      break;
    case 'deleteBackup':
      await handleDeleteBackup(data);
      break;
    case 'reorderPassports':
      await handleReorderPassportIds();
      break;
    default:
      console.log('عملية غير معروفة');
  }
};

// التحقق من صحة النص المُدخل
const isConfirmTextValid = () => {
  return securityModal.userInput === securityModal.confirmText;
};
// استبدل دالة openScheduleForm بهذا:
const openScheduleForm = () => {
  if (schedules.length > 0) {
    const existingTimes = schedules.map(schedule => schedule.time);
    const existingType = schedules[0].backupType || 'sql';
    setScheduleData({ 
      times: existingTimes, 
      backupType: existingType 
    });
  } else {
    setScheduleData({ times: ['09:00'], backupType: 'sql' });
  }
  setShowScheduleForm(true);
};


  // تحميل نسخة احتياطية
  const handleDownloadBackup = (filename) => {
    const link = document.createElement('a');
    link.href = `${config.API_BASE_URL}/api/backup/download/${filename}`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // حذف نسخة احتياطية
  const handleDeleteBackup = async (filename) => {
    if (window.confirm(`هل أنت متأكد من حذف النسخة الاحتياطية: ${filename}؟`)) {
      try {
        const response = await fetch(`${config.API_BASE_URL}/api/backup/delete/${filename}`, {
          method: 'DELETE'
        });

        const data = await response.json();

        if (data.success) {
          showMessage('تم حذف النسخة الاحتياطية بنجاح', 'success');
          fetchBackupList();
        } else {
          showMessage(data.message || 'فشل في حذف النسخة الاحتياطية', 'error');
        }
      } catch (error) {
        showMessage('خطأ في الاتصال بالخادم', 'error');
      }
    }
  };



  // أضف هذه الدالة في DatabaseBackup.js
const handleNativeBackup = async () => {
  setLoading(true);
  try {
    const response = await fetch(`${config.API_BASE_URL}/api/backup/native`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (data.success) {
      showMessage(`تم إنشاء النسخة الأصلية بنجاح! اسم الملف: ${data.fileName} (${data.fileSize})`, 'success');
      fetchBackupList(); // لتحديث القائمة
    } else {
      showMessage(data.message || 'فشل في إنشاء النسخة الاحتياطية الأصلية', 'error');
    }
  } catch (error) {
    showMessage('خطأ في الاتصال بالخادم', 'error');
  } finally {
    setLoading(false);
  }
};

  // دالة استعادة النسخة الاحتياطية
  const handleRestoreBackup = async (filename, cleanRestore = false) => {
    setLoading(true);
    try {
      const endpoint = cleanRestore ? 'restore-clean' : 'restore';
      const response = await fetch(`${config.API_BASE_URL}/api/backup/${endpoint}/${filename}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (data.success) {
        showMessage(data.message, 'success');
        setRestoreModal({ open: false, filename: '', type: '' });
      } else {
        showMessage(data.message || 'فشل في استعادة النسخة الاحتياطية', 'error');
      }
    } catch (error) {
      showMessage('خطأ في الاتصال بالخادم', 'error');
    } finally {
      setLoading(false);
    }
  };

  // حذف جداول محددة
// حذف جداول محددة بترتيب آمن
const handleDeleteTables = async (tableGroup) => {
    setLoading(true);
    try {
      console.log(`🗑️ بدء حذف مجموعة: ${tableGroup.name}`);
      
      // إرسال طلب الحذف للـ backend
      const response = await fetch(`${config.API_BASE_URL}/api/backup/delete-tables-safe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
          tables: tableGroup.tables,
          groupName: tableGroup.name 
        })
      });
  
      const result = await response.json();
  
      if (response.ok && result.success) {
        showMessage(
          `تم حذف ${tableGroup.name} بنجاح! حُذف ${result.totalDeletedRecords} سجل من ${result.deletedTablesCount} جدول`, 
          'success'
        );
      } else {
        showMessage(result.message || `فشل في حذف ${tableGroup.name}`, 'error');
      }
      
    } catch (error) {
      console.error('💥 خطأ في حذف الجداول:', error);
      showMessage(`فشل في حذف ${tableGroup.name}: ${error.message}`, 'error');
    } finally {
      setLoading(false);
      setConfirmModal({ open: false, type: '', table: '' });
    }
  };

  // حذف قاعدة البيانات بالكامل
  const handleDeleteAllDatabase = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${config.API_BASE_URL}/api/backup/delete-all`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const result = await response.json();

      if (response.ok) {
        showMessage('تم حذف قاعدة البيانات بالكامل وإعادة تعيين الـ ID', 'success');
      } else {
        showMessage(result.message || 'فشل في حذف قاعدة البيانات', 'error');
      }
    } catch (error) {
      showMessage('خطأ في الاتصال بالخادم', 'error');
    } finally {
      setLoading(false);
      setConfirmModal({ open: false, type: '', table: '' });
    }
  };

  // فتح نافذة التأكيد
  const openConfirmModal = (type, tableGroup = null) => {
    setConfirmModal({ open: true, type, table: tableGroup });
  };

  return (
    <div className="min-h-screen bg-gray-50 overflow-x-hidden" dir="rtl">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
      <div className="max-w-full mx-auto px-3 sm:px-4 lg:px-6">
  <div className="flex flex-col md:flex-row justify-between md:items-center gap-3 min-h-16 py-3 md:py-0">
    <div className="flex items-center w-full md:w-auto">
      <button
        onClick={() => navigate('/')}
        className="ml-4 p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
      >
        <ArrowRight className="h-6 w-6" />
      </button>
      <Database className="h-8 w-8 text-emerald-600" />
      <div className="mr-3 min-w-0">
        <p className="md:hidden text-xs text-emerald-600 font-semibold">مسار / قواعد البيانات</p>
        <h1 className="text-lg md:text-xl font-bold text-gray-900 leading-tight">النسخ الاحتياطي وإدارة قاعدة البيانات</h1>
      </div>
    </div>
    
    {/* زر وضع التطوير */}
    <div className="flex items-center gap-2 w-full md:w-auto">
      <button
        onClick={() => setDevMode(!devMode)}
        className={`flex items-center justify-center gap-2 px-3 py-3 md:py-2 rounded-xl md:rounded-lg text-sm font-medium transition-colors w-full md:w-auto ${
          devMode 
            ? 'bg-orange-100 text-orange-700 border border-orange-300' 
            : 'bg-gray-100 text-gray-700 border border-gray-300'
        }`}
      >
        <Code2 className="w-4 h-4" />
        {devMode ? 'وضع التطوير مفعل' : 'وضع التطوير'}
      </button>
    </div>
  </div>
</div>
      </div>

      {/* Main Content */}
      <div className="max-w-full mx-auto px-3 sm:px-4 lg:px-6 py-4 md:py-6">

        {/* رسائل النجاح والخطأ */}
        {message && (
          <div className={`mb-6 p-4 rounded-lg border ${
            messageType === 'success' 
              ? 'bg-green-50 border-green-200 text-green-700' 
              : 'bg-red-50 border-red-200 text-red-700'
          }`}>
            <div className="flex items-center">
              {messageType === 'success' ? 
                <Check className="w-5 h-5 ml-2" /> : 
                <AlertCircle className="w-5 h-5 ml-2" />
              }
              {message}
            </div>
          </div>
        )}

        {/* الصف الأول - النسخ الاحتياطي والجدولة */}
<div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 md:gap-4 mb-6">
  {/* النسخ الاحتياطي اليدوي */}
  <div className="bg-white rounded-lg shadow-sm border border-gray-200">
    <div className="bg-gradient-to-r from-emerald-500 to-emerald-600 p-4 rounded-t-lg">
      <div className="flex items-center">
        <Save className="w-6 h-6 text-white ml-2" />
        <h2 className="text-lg font-bold text-white">نسخة SQL</h2>
      </div>
    </div>
    <div className="p-4">
      <div className="bg-blue-50 p-3 rounded-lg border border-blue-200 mb-3">
        <p className="text-sm text-blue-700">
          نسخة كاملة في ملف SQL قابل للقراءة والتعديل
        </p>
      </div>
      <button
        onClick={handleFullBackup}
        disabled={loading}
        className="w-full flex items-center justify-center px-3 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50"
      >
        {loading ? (
          <RefreshCw className="animate-spin w-4 h-4 ml-2" />
        ) : (
          <Save className="w-4 h-4 ml-2" />
        )}
        {loading ? 'جاري الإنشاء...' : 'إنشاء نسخة SQL'}
      </button>
    </div>
  </div>

  {/* نسخة احتياطية أصلية */}
  <div className="bg-white rounded-lg shadow-sm border border-gray-200">
    <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-4 rounded-t-lg">
      <div className="flex items-center">
        <Database className="w-6 h-6 text-white ml-2" />
        <h2 className="text-lg font-bold text-white">نسخة أصلية</h2>
      </div>
    </div>
    <div className="p-4">
      <div className="bg-green-50 p-3 rounded-lg border border-green-200 mb-3">
        <p className="text-sm text-green-700">
          نسخة كاملة مضغوطة (.json.gz)
        </p>
      </div>
      <button
        onClick={handleNativeBackup}
        disabled={loading}
        className="w-full flex items-center justify-center px-3 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50"
      >
        {loading ? (
          <RefreshCw className="animate-spin w-4 h-4 ml-2" />
        ) : (
          <Database className="w-4 h-4 ml-2" />
        )}
        {loading ? 'جاري الإنشاء...' : 'إنشاء نسخة'}
      </button>
    </div>
  </div>

  {/* جدولة النسخ */}
  <div className="bg-white rounded-lg shadow-sm border border-gray-200">
    <div className="bg-gradient-to-r from-purple-500 to-purple-600 p-4 rounded-t-lg">
      <div className="flex items-center">
        <Clock className="w-6 h-6 text-white ml-2" />
        <h2 className="text-lg font-bold text-white">النسخ التلقائي</h2>
      </div>
    </div>
    <div className="p-4">
      {schedules.length > 0 ? (
        <div className="bg-green-50 p-3 rounded-lg border border-green-200 mb-3">
          <div className="text-xs text-green-700">
            <div className="font-medium mb-1">
              {schedules[0]?.backupType === 'both' ? 'SQL + أصلية' :
               schedules[0]?.backupType === 'bak' ? 'أصلية فقط' : 'SQL فقط'}
            </div>
            <div>أوقات: {schedules.map(s => s.time).join(', ')}</div>
          </div>
        </div>
      ) : (
        <div className="bg-gray-50 p-3 rounded-lg border border-gray-200 mb-3">
          <p className="text-gray-600 text-xs">غير مفعل</p>
        </div>
      )}
      
      <div className="flex gap-2">
        <button
          onClick={openScheduleForm}
          className="flex-1 bg-purple-600 hover:bg-purple-700 text-white px-2 py-2 rounded text-xs flex items-center justify-center gap-1"
        >
          <Settings className="w-3 h-3" />
          {schedules.length > 0 ? 'تعديل' : 'إعداد'}
        </button>
        
        {schedules.length > 0 && (
          <button
            onClick={handleStopSchedule}
            className="flex-1 bg-red-600 hover:bg-red-700 text-white px-2 py-2 rounded text-xs flex items-center justify-center gap-1"
          >
            <Pause className="w-3 h-3" />
            إيقاف
          </button>
        )}
      </div>
    </div>
  </div>

  {/* حذف قاعدة البيانات */}
  <div className="bg-white rounded-lg shadow-sm border border-gray-200">
    <div className="bg-gradient-to-r from-red-500 to-red-600 p-4 rounded-t-lg">
      <div className="flex items-center">
        <Trash2 className="w-6 h-6 text-white ml-2" />
        <h2 className="text-lg font-bold text-white">حذف شامل</h2>
      </div>
    </div>
    <div className="p-4">
      <div className="bg-red-50 p-3 rounded-lg border border-red-200 mb-3">
        <p className="text-xs text-red-700">
          ⚠️ حذف جميع البيانات وإعادة تعيين الـ ID
        </p>
      </div>
      <button
        onClick={() => openSecurityModal('danger', 'deleteAll')}
        disabled={loading}
        className="w-full flex items-center justify-center px-3 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 disabled:opacity-50"
      >
        <Trash2 className="w-4 h-4 ml-2" />
        حذف الكل
      </button>
    </div>
  </div>
</div>


        {/* إعادة ترتيب أرقام الجوازات */}
{/* قسم أدوات التطوير - مخفي إلا في وضع التطوير */}
{devMode && (
  <div className="mb-6">
    <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <Code2 className="w-5 h-5 text-orange-600 ml-2" />
          <h3 className="text-lg font-medium text-orange-800">أدوات التطوير</h3>
        </div>
        <span className="bg-orange-200 text-orange-800 px-2 py-1 rounded text-xs font-medium">
          وضع التطوير
        </span>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* إعادة ترقيم الجوازات */}
        <div className="bg-white border border-orange-200 rounded-lg p-4">
          <div className="flex items-center mb-2">
            <Settings className="w-4 h-4 text-indigo-600 ml-2" />
            <h4 className="font-medium text-gray-900">إعادة ترقيم الجوازات</h4>
          </div>
          <p className="text-xs text-gray-600 mb-3">
            إعادة ترقيم جميع الجوازات بترتيب تاريخ الإضافة
          </p>
          <button
            onClick={() => openSecurityModal('warning', 'reorderPassports')}
            disabled={loading || reorderLoading}
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-2 rounded text-sm flex items-center justify-center gap-2"
          >
            <Settings className="w-4 h-4" />
            إعادة ترقيم
          </button>
        </div>

        {/* أدوات أخرى مستقبلية */}
        <div className="bg-white border border-orange-200 rounded-lg p-4">
          <div className="flex items-center mb-2">
            <Database className="w-4 h-4 text-gray-400 ml-2" />
            <h4 className="font-medium text-gray-400">أداة مستقبلية</h4>
          </div>
          <p className="text-xs text-gray-400 mb-3">
            قريباً...
          </p>
          <button
            disabled
            className="w-full bg-gray-300 text-gray-500 px-3 py-2 rounded text-sm cursor-not-allowed"
          >
            غير متاح
          </button>
        </div>

        <div className="bg-white border border-orange-200 rounded-lg p-4">
          <div className="flex items-center mb-2">
            <Shield className="w-4 h-4 text-gray-400 ml-2" />
            <h4 className="font-medium text-gray-400">أداة مستقبلية</h4>
          </div>
          <p className="text-xs text-gray-400 mb-3">
            قريباً...
          </p>
          <button
            disabled
            className="w-full bg-gray-300 text-gray-500 px-3 py-2 rounded text-sm cursor-not-allowed"
          >
            غير متاح
          </button>
        </div>
      </div>
    </div>
  </div>
)}



        {/* قائمة النسخ الاحتياطية المحفوظة */}
        <div className="mt-6 md:mt-8 bg-white rounded-2xl md:rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="bg-gradient-to-r from-purple-500 to-purple-600 p-4 md:p-6 md:rounded-t-lg">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
              <div className="flex items-center">
                <Archive className="w-8 h-8 text-white ml-3" />
                <h2 className="text-lg md:text-xl font-bold text-white">النسخ الاحتياطية المحفوظة</h2>
              </div>
              <div className="flex items-center gap-2">
                {/* رفع نسخة من الجهاز (نسخة متنزلة قبل كده، أو ملف نقل البيانات من النظام القديم) */}
                <label className={`bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-1 rounded-md text-sm cursor-pointer flex items-center gap-1 ${uploadingBackup ? 'opacity-50 pointer-events-none' : ''}`}>
                  <Upload className="w-4 h-4" />
                  {uploadingBackup ? 'جاري الرفع...' : 'رفع نسخة من الجهاز'}
                  <input type="file" accept=".gz,.json.gz" className="hidden" onChange={handleUploadBackup} />
                </label>
                <button
                  onClick={fetchBackupList}
                  disabled={loadingBackups}
                  className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-3 py-1 rounded-md text-sm"
                >
                  {loadingBackups ? 'جاري التحديث...' : 'تحديث'}
                </button>
              </div>
            </div>
          </div>
          <div className="p-4 md:p-6">
            {loadingBackups ? (
              <div className="text-center py-8">
                <RefreshCw className="animate-spin w-8 h-8 text-purple-600 mx-auto mb-2" />
                <p className="text-gray-600">جاري تحميل النسخ الاحتياطية...</p>
              </div>
            ) : backupFiles.length === 0 ? (
              <div className="text-center py-8">
                <Archive className="w-12 h-12 text-gray-400 mx-auto mb-2" />
                <p className="text-gray-600">لا توجد نسخ احتياطية محفوظة</p>
              </div>
            ) : (
           // استبدل جدول النسخ الاحتياطية بهذا:
<>
<div className="hidden md:block overflow-x-auto">
  <table className="w-full border-collapse">
    <thead>
      <tr className="bg-gray-50">
        <th className="border p-3 text-right">اسم الملف</th>
        <th className="border p-3 text-right">النوع</th>
        <th className="border p-3 text-right">الحجم</th>
        <th className="border p-3 text-right">تاريخ الإنشاء</th>
        <th className="border p-3 text-right">الإجراءات</th>
      </tr>
    </thead>
    <tbody>
      {backupFiles.map((file, index) => {
        console.log(`🗂️ عرض ملف ${index + 1}:`, file);
        return (
          <tr key={index} className="hover:bg-gray-50">
            <td className="border p-3 font-mono text-sm">
              {file.name || 'غير محدد'}
            </td>
            <td className="border p-3">
              <span className={`px-2 py-1 rounded text-xs ${
                file.type === 'تلقائي' || file.type === 'تلقائي أصلي'
                  ? 'bg-green-100 text-green-700' 
                  : file.type === 'أصلي (.bak)'
                  ? 'bg-purple-100 text-purple-700'
                  : 'bg-blue-100 text-blue-700'
              }`}>
                {file.type || 'غير محدد'}
              </span>
            </td>
            <td className="border p-3">
              {file.size || 'غير محدد'}
            </td>
            <td className="border p-3">
              {file.created ? new Date(file.created).toLocaleString('ar-EG', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
              }) : 'غير محدد'}
            </td>
            <td className="border p-3">
              <div className="flex space-x-2 space-x-reverse">
                {/* زر التحميل */}
                <button
                  onClick={() => handleDownloadBackup(file.name)}
                  className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm flex items-center gap-1"
                  title="تحميل النسخة الاحتياطية"
                >
                  <Download className="w-4 h-4" />
                  تحميل
                </button>
                
                {/* أزرار حسب النوع */}
                {file.extension === 'bak' ? (
                  // للملفات .bak
                  <button
                    onClick={() => openSecurityModal('warning', 'restoreNative', file.name)}
                    className="bg-purple-500 hover:bg-purple-600 text-white px-3 py-1 rounded text-sm flex items-center gap-1"
                    title="استعادة النسخة الأصلية"
                  >
                    <Database className="w-4 h-4" />
                    استعادة أصلية
                  </button>
                ) : (
                  // للملفات .sql
                  <>
                    <button
                      onClick={() => openSecurityModal('info', 'restoreAdd', file.name)}
                      className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-sm flex items-center gap-1"
                      title="إضافة البيانات"
                    >
                      <Plus className="w-4 h-4" />
                      إضافة
                    </button>
                    
                    <button
                      onClick={() => openSecurityModal('warning', 'restoreReplace', file.name)}
                      className="bg-orange-500 hover:bg-orange-600 text-white px-3 py-1 rounded text-sm flex items-center gap-1"
                      title="استبدال البيانات"
                    >
                      <RefreshCw className="w-4 h-4" />
                      استبدال
                    </button>
                  </>
                )}
                
                {/* زر الحذف */}
                <button
                  onClick={() => openSecurityModal('danger', 'deleteBackup', file.name)}
                  className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm flex items-center gap-1"
                  title="حذف النسخة الاحتياطية"
                >
                  <Trash2 className="w-4 h-4" />
                  حذف
                </button>
              </div>
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
</div>
<div className="md:hidden space-y-3">
  {backupFiles.map((file, index) => (
    <div key={index} className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
      <div className="h-1.5 bg-gradient-to-l from-purple-500 to-blue-500" />
      <div className="p-4 space-y-3">
        <div className="flex justify-between items-start gap-3">
          <div className="min-w-0">
            <p className="text-xs text-gray-500">ملف نسخة احتياطية</p>
            <h3 className="font-mono text-sm font-bold text-gray-900 break-all">{file.name || 'غير محدد'}</h3>
          </div>
          <span className={`shrink-0 px-2 py-1 rounded-full text-xs ${
            file.type === 'تلقائي' || file.type === 'تلقائي أصلي'
              ? 'bg-green-100 text-green-700'
              : file.type === 'أصلي (.bak)'
              ? 'bg-purple-100 text-purple-700'
              : 'bg-blue-100 text-blue-700'
          }`}>{file.type || 'غير محدد'}</span>
        </div>
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div className="bg-gray-50 rounded-xl p-3"><span className="block text-gray-500 text-xs">الحجم</span><span className="font-semibold">{file.size || 'غير محدد'}</span></div>
          <div className="bg-gray-50 rounded-xl p-3"><span className="block text-gray-500 text-xs">التاريخ</span><span className="font-semibold">{file.created ? new Date(file.created).toLocaleString('ar-EG', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }) : 'غير محدد'}</span></div>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <button onClick={() => handleDownloadBackup(file.name)} className="bg-blue-50 text-blue-700 border border-blue-100 rounded-xl py-2.5 flex items-center justify-center gap-1 font-semibold text-sm"><Download className="w-4 h-4" /> تحميل</button>
          {file.extension === 'bak' ? (
            <button onClick={() => openSecurityModal('warning', 'restoreNative', file.name)} className="bg-purple-50 text-purple-700 border border-purple-100 rounded-xl py-2.5 flex items-center justify-center gap-1 font-semibold text-sm"><Database className="w-4 h-4" /> استعادة</button>
          ) : (
            <button onClick={() => openSecurityModal('info', 'restoreAdd', file.name)} className="bg-green-50 text-green-700 border border-green-100 rounded-xl py-2.5 flex items-center justify-center gap-1 font-semibold text-sm"><Plus className="w-4 h-4" /> إضافة</button>
          )}
          {file.extension !== 'bak' && (
            <button onClick={() => openSecurityModal('warning', 'restoreReplace', file.name)} className="bg-orange-50 text-orange-700 border border-orange-100 rounded-xl py-2.5 flex items-center justify-center gap-1 font-semibold text-sm"><RefreshCw className="w-4 h-4" /> استبدال</button>
          )}
          <button onClick={() => openSecurityModal('danger', 'deleteBackup', file.name)} className="bg-red-50 text-red-700 border border-red-100 rounded-xl py-2.5 flex items-center justify-center gap-1 font-semibold text-sm"><Trash2 className="w-4 h-4" /> حذف</button>
        </div>
      </div>
    </div>
  ))}
</div>
</>
            )}
          </div>
        </div>

        {/* حذف بيانات محددة */}
        <div className="mt-6 md:mt-8 bg-white rounded-2xl md:rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="bg-gradient-to-r from-orange-500 to-orange-600 p-4 md:p-6 md:rounded-t-lg">
            <div className="flex items-center">
              <Shield className="w-8 h-8 text-white ml-3" />
              <h2 className="text-xl font-bold text-white">حذف بيانات محددة</h2>
            </div>
          </div>
          <div className="p-4 md:p-6">
            <p className="text-gray-600 mb-6">اختر القسم الذي تريد حذف بياناته. سيتم حذف جميع البيانات المرتبطة بهذا القسم.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {databaseTables.map((tableGroup, index) => (
                <div key={index} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className={`${tableGroup.color} ml-3`}>
                      {tableGroup.icon}
                    </div>
                    <h3 className="font-medium text-gray-900">{tableGroup.name}</h3>
                  </div>
                  <p className="text-sm text-gray-600 mb-4">{tableGroup.description}</p>
                  <button
  onClick={() => openSecurityModal('danger', 'deleteTables', tableGroup)}
  disabled={loading}
  className="w-full flex items-center justify-center px-3 py-2 border border-red-300 rounded-md shadow-sm text-sm font-medium text-red-700 bg-white hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50"
>
  <Trash2 className="w-4 h-4 ml-2" />
  حذف {tableGroup.name}
</button>
                </div>
              ))}
            </div>
          </div>
        </div>
        </div>

     {/* نافذة إعداد الجدولة */}
  
{showScheduleForm && (
  <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-stretch md:items-start justify-center md:p-4">
    <div className="relative md:top-12 mx-auto p-4 md:p-5 border w-full md:w-96 shadow-lg rounded-none md:rounded-md bg-white h-[100dvh] md:h-auto overflow-y-auto">
      <div className="mt-3">
        <h3 className="text-lg font-medium text-gray-900 text-center mb-4">
          {schedules.length > 0 ? 'تعديل جدولة النسخ الاحتياطي' : 'إعداد جدولة النسخ الاحتياطي'}
        </h3>
        
        <div className="space-y-4">
          <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
            <p className="text-sm text-blue-700">
              💡 <strong>ملاحظة:</strong> حدد نوع النسخة والأوقات التي تريد عمل نسخ احتياطي تلقائي فيها (يومياً).
            </p>
          </div>

          {/* اختيار نوع النسخة الاحتياطية */}
       
<div className="mb-4">
  <label className="block text-sm font-medium text-gray-700 mb-2">نوع النسخة التلقائية:</label>
  <div className="grid grid-cols-1 gap-2">
    <label className="flex items-center p-3 border rounded-lg cursor-pointer hover:bg-gray-50">
      <input
        type="radio"
        name="backupType"
        value="sql"
        checked={scheduleData.backupType === 'sql'}
        onChange={(e) => setScheduleData(prev => ({ ...prev, backupType: e.target.value }))}
        className="ml-3"
      />
      <div>
        <div className="font-medium text-gray-900">نسخة SQL (.sql) فقط</div>
        <div className="text-sm text-gray-500">سريعة ومرنة، يمكن قراءتها وتعديلها</div>
      </div>
    </label>
    
    <label className="flex items-center p-3 border rounded-lg cursor-pointer hover:bg-gray-50">
      <input
        type="radio"
        name="backupType" 
        value="bak"
        checked={scheduleData.backupType === 'bak'}
        onChange={(e) => setScheduleData(prev => ({ ...prev, backupType: e.target.value }))}
        className="ml-3"
      />
      <div>
        <div className="font-medium text-gray-900">نسخة أصلية (.bak) فقط</div>
        <div className="text-sm text-gray-500">مضغوطة وموثوقة، حجم أصغر وسرعة أعلى</div>
      </div>
    </label>
    
    <label className="flex items-center p-3 border-2 border-purple-200 bg-purple-50 rounded-lg cursor-pointer hover:bg-purple-100">
      <input
        type="radio"
        name="backupType" 
        value="both"
        checked={scheduleData.backupType === 'both'}
        onChange={(e) => setScheduleData(prev => ({ ...prev, backupType: e.target.value }))}
        className="ml-3"
      />
      <div>
        <div className="font-medium text-purple-900">الاثنين معاً</div>
        <div className="text-sm text-purple-700">ينشئ نسخة SQL ونسخة أصلية في نفس الوقت 🎯</div>
      </div>
    </label>
  </div>
</div>
          
          {/* الأوقات */}
          {scheduleData.times.map((time, index) => (
            <div key={index} className="flex items-center space-x-2 space-x-reverse">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  الوقت {index + 1}:
                </label>
                <input
                  type="time"
                  value={time}
                  onChange={(e) => updateTimeSlot(index, e.target.value)}
                  className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>
              {scheduleData.times.length > 1 && (
                <button
                  onClick={() => removeTimeSlot(index)}
                  className="mt-6 text-red-600 hover:text-red-800 hover:bg-red-50 p-2 rounded"
                  title="حذف هذا الوقت"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              )}
            </div>
          ))}
          
          <button
            onClick={addTimeSlot}
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded border border-gray-300 flex items-center justify-center gap-2 transition-colors"
          >
            <Plus className="w-4 h-4" />
            إضافة وقت آخر
          </button>

          // تعديل جزء المعاينة:
{scheduleData.times.some(time => time && time.includes(':')) && (
  <div className="bg-green-50 p-3 rounded-lg border border-green-200">
    <p className="text-sm text-green-700 font-medium mb-1">معاينة الجدولة:</p>
    <div className="text-sm text-green-600">
      <div className="font-medium mb-1">
        نوع النسخة: {
          scheduleData.backupType === 'both' ? 'الاثنين معاً (SQL + أصلية)' :
          scheduleData.backupType === 'bak' ? 'أصلية (.bak)' : 'SQL (.sql)'
        }
      </div>
      <ul>
        {scheduleData.times.filter(time => time && time.includes(':')).map((time, index) => (
          <li key={index}>
            • {scheduleData.backupType === 'both' ? 'نسختين احتياطيتين' : 'نسخة احتياطية'} يومياً في {time}
          </li>
        ))}
      </ul>
    </div>
  </div>
)}
        </div>
        
        <div className="flex flex-col-reverse md:flex-row justify-end gap-2 md:space-x-2 md:space-x-reverse mt-6">
          <button
            onClick={handleSaveSchedule}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded transition-colors"
          >
            حفظ الجدولة
          </button>
          <button
            onClick={() => {
              setShowScheduleForm(false);
              setScheduleData({ times: ['09:00'], backupType: 'sql' });
            }}
            className="bg-gray-300 hover:bg-gray-400 text-gray-700 px-6 py-2 rounded transition-colors"
          >
            إلغاء
          </button>
        </div>
      </div>
    </div>
  </div>
)}




{/* نافذة الأمان والحماية */}
{securityModal.open && (
  <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-stretch md:items-center justify-center z-50 md:p-4">
    <div className="bg-white rounded-none md:rounded-lg shadow-2xl md:max-w-md w-full h-[100dvh] md:h-auto overflow-y-auto">
      {/* Header */}
      <div className={`p-6 rounded-t-lg ${
        securityModal.type === 'danger' 
          ? 'bg-gradient-to-r from-red-600 to-red-700' 
          : 'bg-gradient-to-r from-orange-600 to-orange-700'
      }`}>
        <div className="flex items-center text-white">
          <div className="flex-shrink-0">
            {securityModal.type === 'danger' ? (
              <div className="w-12 h-12 bg-red-800 rounded-full flex items-center justify-center">
                <AlertCircle className="w-6 h-6" />
              </div>
            ) : (
              <div className="w-12 h-12 bg-orange-800 rounded-full flex items-center justify-center">
                <AlertCircle className="w-6 h-6" />
              </div>
            )}
          </div>
          <div className="mr-4">
            <h3 className="text-lg font-bold">
              {securityModal.type === 'danger' ? '⚠️ تحذير أمني خطير' : '🔒 تأكيد أمني مطلوب'}
            </h3>
            <p className="text-sm opacity-90">
              {securityModal.type === 'danger' 
                ? 'عملية خطيرة قد تؤدي لفقدان البيانات' 
                : 'عملية حساسة تحتاج تأكيد'}
            </p>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="p-6">
        {securityModal.step === 1 && (
          <div className="text-center">
            <div className={`w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center ${
              securityModal.type === 'danger' ? 'bg-red-100' : 'bg-orange-100'
            }`}>
              <div className={`text-3xl font-bold ${
                securityModal.type === 'danger' ? 'text-red-600' : 'text-orange-600'
              }`}>
                {securityModal.countdown}
              </div>
            </div>
            
            <h4 className="text-lg font-medium text-gray-900 mb-3">
              أنت على وشك تنفيذ:
            </h4>
            
            <div className={`p-4 rounded-lg mb-4 ${
              securityModal.type === 'danger' 
                ? 'bg-red-50 border border-red-200' 
                : 'bg-orange-50 border border-orange-200'
            }`}>
              <p className={`font-medium ${
                securityModal.type === 'danger' ? 'text-red-800' : 'text-orange-800'
              }`}>
                {securityModal.confirmText}
              </p>
            </div>

            {securityModal.type === 'danger' && (
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
                <div className="flex items-start">
                  <AlertCircle className="w-5 h-5 text-yellow-600 mt-0.5 ml-2" />
                  <div className="text-sm text-yellow-800">
                    <p className="font-medium mb-1">⚠️ تحذيرات هامة:</p>
                    <ul className="list-disc list-inside space-y-1 text-xs">
                      <li>هذه العملية لا يمكن التراجع عنها</li>
                      <li>قد تفقد بيانات مهمة نهائياً</li>
                      <li>تأكد من وجود نسخة احتياطية حديثة</li>
                      <li>لن تكون مسؤولين عن أي فقدان بيانات</li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            <p className="text-sm text-gray-600 mb-4">
              {securityModal.countdown > 0 
                ? `انتظر ${securityModal.countdown} ثانية قبل المتابعة...`
                : 'يمكنك الآن المتابعة للخطوة التالية'
              }
            </p>

            <div className="flex flex-col md:flex-row gap-2 md:space-x-3 md:space-x-reverse">
              <button
                onClick={nextSecurityStep}
                disabled={securityModal.countdown > 0}
                className={`flex-1 px-4 py-2 rounded-lg font-medium transition-all ${
                  securityModal.countdown > 0
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : securityModal.type === 'danger'
                      ? 'bg-red-600 hover:bg-red-700 text-white'
                      : 'bg-orange-600 hover:bg-orange-700 text-white'
                }`}
              >
                متابعة للتأكيد النهائي
              </button>
              <button
                onClick={closeSecurityModal}
                className="flex-1 px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded-lg font-medium"
              >
                إلغاء العملية
              </button>
            </div>
          </div>
        )}

        {securityModal.step === 2 && (
          <div>
            <div className="text-center mb-6">
              <div className={`w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center ${
                securityModal.type === 'danger' ? 'bg-red-100' : 'bg-orange-100'
              }`}>
                <Shield className={`w-8 h-8 ${
                  securityModal.type === 'danger' ? 'text-red-600' : 'text-orange-600'
                }`} />
              </div>
              
              <h4 className="text-lg font-medium text-gray-900 mb-2">
                التأكيد النهائي مطلوب
              </h4>
              
              <p className="text-sm text-gray-600 mb-4">
                اكتب النص التالي بالضبط للتأكيد:
              </p>
              
              <div className={`p-3 rounded-lg mb-4 font-mono text-sm ${
                securityModal.type === 'danger' 
                  ? 'bg-red-50 border border-red-200 text-red-800' 
                  : 'bg-orange-50 border border-orange-200 text-orange-800'
              }`}>
                {securityModal.confirmText}
              </div>
            </div>

            <div className="mb-6">
              <input
                type="text"
                value={securityModal.userInput}
                onChange={(e) => setSecurityModal(prev => ({ ...prev, userInput: e.target.value }))}
                placeholder="اكتب النص هنا للتأكيد..."
                className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none font-mono text-sm ${
                  isConfirmTextValid()
                    ? 'border-green-500 bg-green-50 text-green-800'
                    : 'border-gray-300 focus:border-blue-500'
                }`}
                autoFocus
              />
              
              {securityModal.userInput && !isConfirmTextValid() && (
                <p className="text-red-600 text-xs mt-2 flex items-center">
                  <AlertCircle className="w-4 h-4 ml-1" />
                  النص غير مطابق - يجب الكتابة بالضبط كما هو مكتوب أعلاه
                </p>
              )}
              
              {isConfirmTextValid() && (
                <p className="text-green-600 text-xs mt-2 flex items-center">
                  <Check className="w-4 h-4 ml-1" />
                  النص مطابق - يمكن المتابعة الآن
                </p>
              )}
            </div>

            <div className="flex flex-col md:flex-row gap-2 md:space-x-3 md:space-x-reverse">
              <button
                onClick={nextSecurityStep}
                disabled={!isConfirmTextValid()}
                className={`flex-1 px-4 py-3 rounded-lg font-medium transition-all ${
                  isConfirmTextValid()
                    ? securityModal.type === 'danger'
                      ? 'bg-red-600 hover:bg-red-700 text-white'
                      : 'bg-orange-600 hover:bg-orange-700 text-white'
                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }`}
              >
                {securityModal.type === 'danger' ? '🔥 تنفيذ العملية الخطيرة' : '✅ تأكيد وتنفيذ'}
              </button>
              <button
                onClick={closeSecurityModal}
                className="flex-1 px-4 py-3 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded-lg font-medium"
              >
                إلغاء العملية
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
)}


   </div>
 );
};

export default DatabaseBackup;